import styled from 'styled-components';
import { Button } from 'antd';
export const StyledFCardContainer = styled.div`
  display: flex;
  flex-direction: row;

  padding-right: 50px;
`;
export const StyledPrimaryButton = styled(Button)`
  background: #1890ff !important; /* blue background */
  color: #fff !important; /* white text */
  font-size: 20px; /* larger font */
  font-weight: 600;
  height: 56px; /* bigger height */
  padding: 0 36px; /* more horizontal space */
  border-radius: 6px !important; /* radius 4px */
  border: none;

  &:hover {
    background: white !important; /* lighter blue on hover */
    color: black !important;
  }
`;
